import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const closeRemoteDesktopStep = defineStepConfig({
  type: "close_remote_desktop",
  name: "Close Remote Desktop",
  description: "Close an active remote desktop session.",
  category: "Computer Use",

  inputSchema: z.object({
    sessionId: z.string().optional(),
  }),

  outputSchema: z.object({
    success: z.boolean(),
    message: z.string().nullable(),
    error: z.string().nullable(),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "2 minutes",
    retry: {
      maximumAttempts: 1,
    },
  },
});
